import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { browserHistory } from 'react-router';
import Moment from 'react-moment';
import Pagination from "react-js-pagination";
// import * as constant from '../../../../constants/constant';
import * as adminDashboardActions from '../../../../actions/admin/dashboard/admindashboardActions';
import autoBind from 'auto-bind';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import * as SVGICONS from "../../../../images/img/images";

// import ShowMore from 'react-show-more';
// import '../../styles/css/style.css';
import * as statisticsActions from '../../../../actions/statisticsActions';
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
// import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import * as vettingUserActions from "../../../../actions/admin/vettinguser/vettingUserActions";
// import Switch from "react-switch";
import $ from 'jquery'

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Bar, BarChart, Legend, Label, ScatterChart, Scatter, Area, AreaChart } from 'recharts';
import { isAbsolute } from 'path';
import moment from 'moment';
// import $ from 'jquery';
// import '../../../../customScrollBar.js';
import {
	Button,
} from 'react-bootstrap';

import 'react-datepicker/dist/react-datepicker.css';

class FinanceDashboard extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			tabCLicked: 1,
			Commissions: [],
			dateOfBirth: { value: null, isValid: true, message: '' },
			startDate: moment().startOf('week'),
			endDate:moment().endOf('week'), 
			specialistUserClicked: false,
			ranges: {
				'Today': [moment(), moment()],
				'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
				'Last 7 Days': [moment().subtract(6, 'days'), moment()],
				'Last 30 Days': [moment().subtract(29, 'days'), moment()],
				'This Month': [moment().startOf('month'), moment().endOf('month')],
				'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
			},

			//rate
			rateStats: [],
			filter2: '',
			dateTo2: { value: null, isValid: true, message: '' },
			dateFrom2: { value: null, isValid: true, message: '' },

			//app revenue
			appRevStats: [],
			medfixRevStats: [],
			statusDate3: '',
			filter3: '',
			dateTo3: { value: null, isValid: true, message: '' },
			dateFrom3: { value: null, isValid: true, message: '' },

			//Patient Vs appointment

			filter1: '',
			statistics: [],
			statusDate1: '',
			dateTo1: { value: null, isValid: true, message: '' },
			dateFrom1: { value: null, isValid: true, message: '' },

			//Medfix Revenue
			statusDate4: "",
			dateTo4: { value: null, isValid: true, message: '' },
			dateFrom4: { value: null, isValid: true, message: '' },
			logoutButton: false,
			specialistList: [],
			activePage: 1,
			count: 10,
			status: true,

			//TurnOverCountrystatistics
			filter4: '',
			TurnOverCountrystatistics: [],
			// statusDate4: '',
			// dateTo4: { value: null, isValid: true, message: '' },
			// dateFrom1: { value: null, isValid: true, message: '' },


			//TurnOverF2FONCountrystatistics
			filter5: '',
			TurnOverF2FONCountrystatistics: [],
			statusDate5: '',
			dateTo5: { value: null, isValid: true, message: '' },
			dateFrom5: { value: null, isValid: true, message: '' },


			//getRevenewByStatusCountry
			filter6: '',
			getRevenewByStatusCountry: [],
			statusDate6: '',
			dateTo6: { value: null, isValid: true, message: '' },
			dateFrom6: { value: null, isValid: true, message: '' },


		}

			this.onChange = this.onChange.bind(this),
			this.rateVsPatientSearch = this.rateVsPatientSearch.bind(this),
			this.rateVsPatientReset = this.rateVsPatientReset.bind(this),
			this.appRevenueSearch = this.appRevenueSearch.bind(this),
			this.appRevenueReset = this.appRevenueReset.bind(this)
			this.getMedfixRevenueSearch = this.getMedfixRevenueSearch.bind(this),
			this.patientVsAppointmentSearch = this.patientVsAppointmentSearch.bind(this)
			this.patientVsAppointmentReset = this.patientVsAppointmentReset.bind(this)
			this.sortChanged = this.sortChanged.bind(this),
			this.specialistGraphs = this.specialistGraphs.bind(this)

	}
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		// let patientId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let appointmentObj = {
			token: userToken,
			page: this.state.activePage,
			count: this.state.count,
			sorting: sorting,
			status: this.state.status
		};

		this.props.specialistAction.getAllSpecialists(appointmentObj);
	}
	// function for set sort icon on table header
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	handleApply(startDate, endDate) {
		var state = this.state;
		state.dateFrom4.value = startDate
		state.dateTo4.value = endDate
		state.startDate = startDate,
		state.endDate = endDate,
		state.statusDate4 = ''
		this.setState(state);
		this.getRevenueOfCountryMedfixSearch()
	}
	handleApplyTabB(startDate, endDate) {
		var state = this.state;
		state.dateFrom5.value = startDate
		state.dateTo5.value = endDate
		state.startDate = startDate,
		state.endDate = endDate,
		state.statusDate5 = ''
		this.setState(state);
		this.getRevenueOfCountry()
	}
	handleApplyTabC(startDate, endDate) {
		var state = this.state;
		state.dateFrom6.value = startDate
		state.dateTo6.value = endDate
		state.startDate = startDate,
		state.endDate = endDate,
		state.statusDate6 = ''
		this.setState(state);
		this.getRevenueByStatusandCountry()
	}
	handleApplyTabD(startDate, endDate) {
		var state = this.state;
		state.dateFrom1.value = startDate
		state.dateTo1.value = endDate
		state.startDate = startDate,
		state.endDate = endDate,
		state.statusDate1 = ''
		this.setState(state);
		this.patientVsAppointmentSearch()
	}
	// searchText
	componentWillMount() {
		var obj = {
			userId: localStorage.getItem('userId'),
			filter: "week"
		}
		this.props.action.getPatientVsAppointments(obj);
		this.props.action.getRateVsPatients(obj);
		this.props.action.getAppointmentRevenue(obj);
		this.props.action.getMedfixRevenue(obj);
		this.props.action.getRevenueOfCountryMedfix(obj);
		this.props.action.getRevenueOfCountry(obj);
		this.props.action.getRevenueByStatusandCountry(obj);
		let objectDocument = {
			page: this.state.activePage,
			count: this.state.count,
			status: this.state.status,
			userId: localStorage.getItem("userId")
		};
		this.setState({ status: true })
		this.props.specialistAction.getAllSpecialists(objectDocument);
	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			statistics: nextProps.statistics,
			rateStats: nextProps.rateStats,
			appRevStats: nextProps.appRevStats,
			medfixRevStats: nextProps.medfixRevStats,
			TurnOverCountrystatistics: nextProps.TurnOverCountrystatistics,
			Commissions: nextProps.Commissions,
			TurnOverF2FONCountrystatistics: nextProps.TurnOverF2FONCountrystatistics,
			getRevenewByStatusCountry: nextProps.getRevenewByStatusCountry,
			specialistList: nextProps.specialistList,
			totalCount: nextProps.specialistListCount,
		})

	}


	onChange(event) {

		var state = this.state;
		if (event.target.name == "filter1") {
			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate1 = (event.target.value == "1") ? "week" : "month";
				if(event.target.value == "1"){
					state.startDate = moment().startOf('week');
					state.endDate = moment().endOf('week');
					}else{
						state.startDate = moment().startOf('month');
						state.endDate = moment().endOf('month');
					}
			} else {
				state.statusDate1 = "";
			}
			state.filter1 = event.target.value;
			this.setState(state);
			this.patientVsAppointmentSearch();
		}
		else if (event.target.name == "filter2") {
			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate2 = (event.target.value == "1") ? "week" : "month";
			} else {
				state.statusDate2 = "";
			}
			state.filter2 = event.target.value;
			this.setState(state);
			this.rateVsPatientSearch();
		} else if (event.target.name == "filter3") {

			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate3 = (event.target.value == "1") ? "week" : "month";
			} else {
				state.statusDate3 = "";
			}
			state.filter3 = event.target.value;
			this.setState(state);
			this.appRevenueSearch();
		} else if (event.target.name == "filter4") {

			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate4 = (event.target.value == "1") ? "week" : "month";
				const today = moment();
				if(event.target.value == "1"){
				state.startDate = moment().startOf('week');
				state.endDate = moment().endOf('week');
				}else{
					state.startDate = moment().startOf('month');
					state.endDate = moment().endOf('month');
				}
			} else {
				state.statusDate4 = "";
			}
			state.filter4 = event.target.value;
			this.setState(state);
			this.getRevenueOfCountryMedfixSearch();
		}
		else if (event.target.name == "filter5") {

			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate5 = (event.target.value == "1") ? "week" : "month";
				if(event.target.value == "1"){
					state.startDate = moment().startOf('week');
					state.endDate = moment().endOf('week');
					}else{
						state.startDate = moment().startOf('month');
						state.endDate = moment().endOf('month');
					}
			} else {
				state.statusDate5 = "";
			}
			state.filter5 = event.target.value;
			this.setState(state);
			this.getRevenueOfCountry();
		}
		else if (event.target.name == "filter6") {

			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate6 = (event.target.value == "1") ? "week" : "month";
				if(event.target.value == "1"){
					state.startDate = moment().startOf('week');
					state.endDate = moment().endOf('week');
					}else{
						state.startDate = moment().startOf('month');
						state.endDate = moment().endOf('month');
					}
			} else {
				state.statusDate6 = "";
			}
			state.filter6 = event.target.value;
			this.setState(state);
			this.getRevenueByStatusandCountry();
		}


		else if (event.target.name == "filterMrev") {
			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate4 = (event.target.value == "1") ? "week" : "month";
			} else {
				state.statusDate4 = "";
			}
			state.filterMrev = event.target.value;
			this.setState(state);
			this.getMedfixRevenueSearch();
		}

	}
	getRevenueByStatusandCountry() {

		if ((this.state.filter6 == "1" || this.state.filter6 == "2" || this.state.filter6 == "") || (this.state.filter6 == "3" && this.state.dateTo6.value != null && this.state.dateFrom6.value != null && this.state.dateTo6.message == '')) {
			var obj = {
				userId: localStorage.getItem('userId'),
				filter: this.state.statusDate6,
				fromdate: (this.state.dateFrom6.value == null) ? '' : this.state.dateFrom6.value,
				todate: (this.state.dateTo6.value == null) ? '' : this.state.dateTo6.value
			}
			this.props.action.getRevenueByStatusandCountry(obj);
		} else {
			var state = this.state;
			state.dateTo6.message = (this.state.dateTo6.value == null) ? "Please select start date" : "";
			state.dateFrom6.message = (this.state.dateFrom6.value == null) ? "Please select end date" : "";
			this.setState(state);
		}
	}
	rateVsPatientSearch() {
		if ((this.state.filter2 == "1" || this.state.filter2 == "2" || this.state.filter2 == "") || (this.state.filter2 == "3" && this.state.dateTo2.value != null && this.state.dateFrom2.value != null && this.state.dateTo2.message == '')) {
			var obj = {
				doctorId: localStorage.getItem('doctorId'),
				filter: this.state.statusDate2,
				fromdate: (this.state.dateFrom2.value == null) ? '' : this.state.dateFrom2.value,
				todate: (this.state.dateTo2.value == null) ? '' : this.state.dateTo2.value
			}
			this.props.action.getRateVsPatients(obj);
		} else {
			var state = this.state;
			state.dateTo2.message = (this.state.dateTo2.value == null) ? "Please select start date" : "";
			state.dateFrom2.message = (this.state.dateFrom2.value == null) ? "Please select end date" : "";
			this.setState(state);
		}

	}
	getRevenueOfCountry() {
		if ((this.state.filter5 == "1" || this.state.filter5 == "2" || this.state.filter5 == "") || (this.state.filter5 == "3" && this.state.dateTo5.value != null && this.state.dateFrom5.value != null && this.state.dateTo5.message == '')) {
			var obj = {
				userId: localStorage.getItem('userId'),
				filter: this.state.statusDate5,
				fromdate: (this.state.dateFrom5.value == null) ? '' : this.state.dateFrom5.value,
				todate: (this.state.dateTo4.value == null) ? '' : this.state.dateTo5.value
			}
			this.props.action.getRevenueOfCountry(obj);
		} else {
			var state = this.state;
			state.dateTo5.message = (this.state.dateTo5.value == null) ? "Please select start date" : "";
			state.dateFrom5.message = (this.state.dateFrom5.value == null) ? "Please select end date" : "";
			this.setState(state);
		}

	}

	rateVsPatientReset() {
		var state = this.state;
		state.statusDate2 = '';
		state.filter2 = '';
		state.dateTo2.value = null;
		state.dateFrom2.value = null;

		this.setState(state);
	}

	appRevenueSearch() {

		if ((this.state.filter3 == "1" || this.state.filter3 == "2" || this.state.filter3 == "") || (this.state.filter3 == "3" && this.state.dateTo3.value != null && this.state.dateFrom3.value != null && this.state.dateTo3.message == '')) {
			var obj = {
				doctorId: localStorage.getItem('doctorId'),
				filter: this.state.statusDate3,
				fromdate: (this.state.dateFrom3.value == null) ? '' : this.state.dateFrom3.value,
				todate: (this.state.dateTo3.value == null) ? '' : this.state.dateTo3.value
			}
			this.props.action.getAppointmentRevenue(obj);
		} else {
			var state = this.state;
			state.dateTo3.message = (this.state.dateTo3.value == null) ? "Please select start date" : "";
			state.dateFrom3.message = (this.state.dateFrom3.value == null) ? "Please select end date" : "";
			this.setState(state);
		}
	}

	appRevenueReset() {
		var state = this.state;
		state.statusDate3 = '';
		state.filter3 = '';
		state.dateTo3.value = null;
		state.dateFrom3.value = null;

		this.setState(state);
	}

	getMedfixRevenueSearch() {
		console.log("called dddd", this.state.filterMrev);
		if ((this.state.filterMrev == "1" || this.state.filterMrev == "2" || this.state.filterMrev == "") || (this.state.filterMrev == "3" && this.state.dateTo4.value != null && this.state.dateFrom4.value != null && this.state.dateTo4.message == '')) {
			var obj = {
				doctorId: localStorage.getItem('doctorId'),
				filter: this.state.statusDate4,
				fromdate: (this.state.startDate == null) ? '' : this.state.startDate,
				todate: (this.state.endDate == null) ? '' : this.state.endDate
			}
			this.props.action.getMedfixRevenue(obj);
		} else {
			// var state = this.state;
			// state.dateTo4.message = (this.state.dateTo4.value == null) ? "Please select start date" : "";
			// state.dateFrom4.message = (this.state.dateFrom4.value == null) ? "Please select end date" : "";
			// this.setState(state);
		}
	}
	patientVsAppointmentSearch() {

		if ((this.state.filter1 == "1" || this.state.filter1 == "2" || this.state.filter1 == "") || (this.state.filter1 == "3" && this.state.dateTo1.value != null && this.state.dateFrom1.value != null && this.state.dateTo1.message == '')) {
			var obj = {
				doctorId: localStorage.getItem('doctorId'),
				filter: this.state.statusDate1,
				fromdate: (this.state.dateFrom1.value == null) ? '' : this.state.dateFrom1.value,
				todate: (this.state.dateTo1.value == null) ? '' : this.state.dateTo1.value
			}
			this.props.action.getPatientVsAppointments(obj);
			this.props.action.getRateVsPatients(obj);
			this.props.action.getAppointmentRevenue(obj);
			this.props.action.getMedfixRevenue(obj);

		
			

		} else {
			var state = this.state;
			state.dateTo1.message = (this.state.dateTo1.value == null) ? "Please select start date" : "";
			state.dateFrom1.message = (this.state.dateFrom1.value == null) ? "Please select end date" : "";
			this.setState(state);
		}
	}
	getRevenueOfCountryMedfixSearch() {

		if ((this.state.filter4 == "1" || this.state.filter4 == "2" || this.state.filter4 == "") || (this.state.filter4 == "3" && this.state.dateTo4.value != null && this.state.dateFrom4.value != null && this.state.dateTo.message == '')) {
			var obj = {
				userId: localStorage.getItem('userId'),
				filter: this.state.statusDate4,
				fromdate: (this.state.dateFrom4.value == null) ? '' : this.state.dateFrom4.value,
				todate: (this.state.dateTo4.value == null) ? '' : this.state.dateTo4.value
			}
			this.props.action.getRevenueOfCountryMedfix(obj);
		} else {
			var state = this.state;
			state.dateTo4.message = (this.state.dateTo4.value == null) ? "Please select start date" : "";
			state.dateFrom4.message = (this.state.dateFrom4.value == null) ? "Please select end date" : "";
			this.setState(state);
		}
	}


	patientVsAppointmentReset() {
		var state = this.state;
		state.statusDate1 = '';
		state.filter1 = '';
		state.dateTo1.value = null;
		state.dateFrom1.value = null;
		this.setState(state);
	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');

		let appointmentObj = {
			token: userToken,
			count: this.state.count,
			status: this.state.status,
			page: pageNumber,
			type: 'specialist'
		};
		this.props.specialistAction.getAllSpecialists(appointmentObj);
	}

	onChangeTab(data) {

		this.setState({

			tabCLicked: data
		});
		if (data != 4) {
			this.setState({
				specialistUserClicked: false
			})
		}
		if (data == 4) {
			let objectDocument = {
				page: this.state.activePage,
				count: this.state.count,
				status: this.state.status,
				userId: localStorage.getItem("userId")
			};
			this.setState({
				status: true,
				specialistUserClicked: false
			})
			this.props.specialistAction.getAllSpecialists(objectDocument);
		}


	}
	componentDidMount() {
	// 	$( document ).ready(function( $ ) {
	// 	$("#content-6").mCustomScrollbar({
	// 		axis: "x",
	// 		advanced: { autoExpandHorizontalScroll: true }
	// 	});
	// })

	}
	specialistGraphs(userId) {
		var obj = {
			doctorId: userId,
			filter: "week"
		}
		localStorage.setItem('doctorId', userId)
		this.props.action.getPatientVsAppointments(obj);
		this.props.action.getRateVsPatients(obj);
		this.props.action.getAppointmentRevenue(obj);
		this.props.action.getMedfixRevenue(obj);

		this.setState({
			specialistUserClicked: true
		})
	}
	applyCallback(startDate, endDate, handlingFunction) {
		let that = this;
		var state = that.state;
		state.dateFrom1.value = startDate
		state.dateTo1.value = endDate
		state.startDate = startDate,
			state.endDate = endDate,
			state.statusDate1 = ''
		this.setState(state);
		// console.log('Apply Callback');
		// console.log(startDate.format('DD-MM-YYYY'));
		// console.log(endDate.format('DD-MM-YYYY'));
		// this.setState({
		//   startDate: startDate,
		//   endDate: endDate,
		// });
		handlingFunction();
	}

	rangeCallback(index, value) {
		console.log(index, value);
	}
	renderPickerAutoApply(local, handlingFunction) {
		let value = `${this.state.startDate.format(
			'DD-MM-YYYY',
		)} - ${this.state.endDate.format('DD-MM-YYYY')}`;
		return (
				<DateTimeRangeContainer
					  ranges={false}
					customRangeLabel={false}
					start={this.state.startDate}
					end={this.state.endDate}
					local={local}
					//   maxDate={maxDate}
					applyCallback={handlingFunction}
					rangeCallback={this.rangeCallback}
					autoApply
				>
					{/* <FormControl
						id="formControlsTextB"
						type="text"
						label="Text"
						placeholder="Enter text"
						style={{ cursor: 'pointer' }}
						disabled
						value={value}
					/> */}
					<div className="input-group">
						<input type="text" className="form-control" value={value} />
						<span className="input-group-btn">
							<Button className="default date-range-toggle statsCal">
								<i className="fa fa-calendar" />
							</Button>
						</span>
					</div>
				</DateTimeRangeContainer>
		);
	}
	render() {
		let now = new Date();
		let start = moment(
			new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0),
		);
		let end = moment(start)
			.add(1, 'days')
			.subtract(1, 'seconds');
		let ranges = {
			'Today Only': [moment(start), moment(end)],
			'Yesterday Only': [
				moment(start).subtract(1, 'days'),
				moment(end).subtract(1, 'days'),
			],
			'3 Days': [moment(start).subtract(3, 'days'), moment(end)],
			'5 Days': [moment(start).subtract(5, 'days'), moment(end)],
			'1 Week': [moment(start).subtract(7, 'days'), moment(end)],
			'2 Weeks': [moment(start).subtract(14, 'days'), moment(end)],
			'1 Month': [moment(start).subtract(1, 'months'), moment(end)],
			'90 Days': [moment(start).subtract(90, 'days'), moment(end)],
			'1 Year': [moment(start).subtract(1, 'years'), moment(end)],
		};
		let local = {
			format: 'DD-MM-YYYY HH:mm',
			sundayFirst: false,
		};
		
const getIntroOfPage = (label) => {
	if (label === 'CS') {
		label= 'Courtesy of Staff'
	  return label;
	} if (label === 'CC&C') {
	  return "Clinic Cleanliness & Comfort";
	} if (label === 'WT') {
	  return "Waiting Time";
	} if (label === 'CC') {
	  return 'Consultation Cost';
	} if (label === 'QC') {
	  return 'Quality of Care';
	} 
  };
		const CustomTooltip = ({ active, payload, label }) => {
			if (active) {
			  return (
				<div className="custom-tooltips ">
				  <p className="label">{getIntroOfPage(label)}</p>
				  <p className="labelName">{`Rating: ${payload[0].value}`}</p>
				  {/* <p className="desc">Anything you want can be displayed here.</p> */}
				</div>
			  );
			}
		  
			return null;
		  }
		// let start = this.state.startDate.format('YYYY-MM-DD');
		// let end = this.state.endDate.format('YYYY-MM-DD');
		let label = start + ' - ' + end;
		if (start === end) {
			label = start;
		}

		var rows = [];
		{
			this.state.TurnOverCountrystatistics ?
				this.state.TurnOverCountrystatistics.forEach(function (item, index) {
					rows.push(<tr key={index}>

						<td className="bluecolor">
							{item.name}
						</td>
						<td>
							$ {item.Total_Turn_Over}
						</td>
						<td>
							$ {this.state.Commissions[index].Commission}
						</td>
					</tr>)
				}.bind(this))
				:
				''
		}

		var Revenu_by_appointment_mode = [];
		{
			this.state.TurnOverF2FONCountrystatistics.Total_Turn_Over ?
				this.state.TurnOverF2FONCountrystatistics.Total_Turn_Over.forEach(function (item, index) {
					Revenu_by_appointment_mode.push(<tr key={index}>

						<td className="bluecolor">
							{item.name}
						</td>
						<td>
							$ {item.Total_Turn_Over_Online}
						</td>
						<td>
							$ {item.Total_Turn_Over_F2F}
						</td>
						<td>
							$ {this.state.TurnOverF2FONCountrystatistics.Commission[index].Commission_Online}
						</td>
						<td>
							$ {this.state.TurnOverF2FONCountrystatistics.Commission[index].Commission_F2F}
						</td>


					</tr>)
				}.bind(this))
				:
				''
		}


		var
			Overall_appointment_history = [];
		{
			this.state.getRevenewByStatusCountry ?
				this.state.getRevenewByStatusCountry.forEach(function (item, index) {
					Overall_appointment_history.push(<tr key={index}>

						<td className="bluecolor">
							{item.name}
						</td>
						<td>
							{item.Consulted}
						</td>
						<td>
							{item.Cancelled_By_Patient}
						</td>
						<td>
							{item.Cancelled_By_Specialist}
						</td>
						<td>
							{item.No_Show_Specialist}
						</td>
						<td>
							{item.No_show_Patient}
						</td>
						<td>
							{item.Total}
						</td>


					</tr>)
				}.bind(this))
				:
				''
		}



		var specialistList = this.state.specialistList;
		var allSpecialist = [];
		{
			this.state.specialistList.length > 0 ? this.state.specialistList.forEach(
				function (item, index) {
					var activated = item.users.isActivated == '2' ? '1' : '2'
					allSpecialist.push(
						<tr key={index}>
							<td>
								<Link>{item.users.userName}</Link>
							</td>
							<td>{item.qualification} </td>
							<td>
								{item.specializations.specialization}
							</td>
							<td>
								{item.users.email}
							</td>
							<td>
								{/* {item.isAllVerified == false ? <Link to={"/user/verification/" + item.users._id}><img src={require('../../../../images/images/verify.png')} width="40" height="30" /></Link> :
							<Switch
								// onChange={this.handleChange.bind(this, activated, item.users._id)}
								checked={item.users.isActivated == '2' ? true : false}
								className="react-switch"
								// id={id}
								onColor="#00B6E4"
							/>
						} */}
								<i className="fa " style={{ cursor: "pointer" }}
									onClick={this.specialistGraphs.bind(this, item.users._id)}>	<SVGICONS.Financesvg /></i>
							</td>
						</tr>
					);
				}.bind(this)
			) : <tr><td>No Records Found</td></tr>;
		}

		return (

			<div className="content-wrapper">
				<section className="content container-fluid">

					{/* <ToastContainer /> */}
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs font-weight500" >
										<li><Link to="#tab_1" onClick={this.onChangeTab.bind(this, 1)} data-toggle="tab" className={this.state.tabCLicked === 1 || 2 || 3 || 4 ? "active show" : ''}>Finance User</Link></li>
									</ul>
									<div className="tab-content">

										<div id="content-6" className=" horizontal-images scrollmenu">

											<div className="nav-tabs-custom ">
												<ul className="nav nav-tabs" >
													<li><Link to="#tab_1" onClick={this.onChangeTab.bind(this, 1)} data-toggle="tab" className={this.state.tabCLicked === 1 ? "active show" : ''}>Revenue share with specialist</Link></li>
													<li><Link to="#tab_2" onClick={this.onChangeTab.bind(this, 2)} data-toggle="tab" className={this.state.tabCLicked === 2 ? "active show" : ''}>Revenue by appointment mode</Link></li>
													<li><Link to="#tab_3" onClick={this.onChangeTab.bind(this, 3)} data-toggle="tab" className={this.state.tabCLicked === 3 ? "active show" : ''}>Overall appointment history</Link></li>
													<li><Link to="#tab_4" onClick={this.onChangeTab.bind(this, 4)} data-toggle="tab" className={this.state.tabCLicked === 4 ? "active show" : ''}>Specialist User </Link></li>

												</ul>
											</div>
										</div>

										<div className={this.state.tabCLicked === 1 ? "tab-pane active show" : 'tab-pane'} id="tab_1">

											<form className="width-100">

												<div className="row">
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 tabletpadding0">
														<div className="form-inline inputBg dateBrt beforenone a-auto width100merge">
															<label for="exampleInputEmail1"> Value Range</label>
															<select className="form-control selectBg seltweekly" name="filter4" value={this.state.filter4}
																onChange={this.onChange.bind(this)}
															>
																<option value="1">Weekly</option>
																<option value="2">Monthly</option>
																{/* <option>Yearly</option> */}
															</select>
														</div>
													</div>
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 tabletpadding0">

													</div>
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 tabletpadding0">

														{/* <DatetimeRangePicker
															startDate={this.state.startDate}
															endDate={this.state.endDate}
															onApply={this.handleApply}
														// ranges={this.state.ranges}

														>
															<div className="input-group">
																<input type="text" className="form-control" value={label} />
																<span className="input-group-btn">
																	<Button className="default date-range-toggle">
																		<i className="fa fa-calendar" />
																	</Button>
																</span>
															</div>
														</DatetimeRangePicker> */}
														{this.renderPickerAutoApply(local, this.handleApply)}
													</div>
												</div>

												<div className="row  last-child-merge">
													<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 tabletpadding0">



														<div className="m-t-20">
															{ this.state.TurnOverCountrystatistics && this.state.TurnOverCountrystatistics.length>0 ?
															<BarChart className="chartCss" width={1000} height={315} data={this.state.TurnOverCountrystatistics}
																margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																<CartesianGrid strokeDasharray="3 3" />
																<XAxis dataKey="name" className="capitalize" />
																<YAxis orientation="left" >
																	<Label angle={-90} value='Revenue ($)' offset={-10} position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																</YAxis>
																<Tooltip />
																{/* <Legend /> */}
																<Bar name="Total Turn Over" dataKey="Total_Turn_Over" fill="#00b5e8" barSize={25} />
															</BarChart>
															:<div className='nodatafound' style={{}}>No data found</div>}
															<p className="overall-title">Total Turn Over Revenue</p>
														</div>
													</div>

													<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 tabletpadding0">

														<div className="m-t-20">
															{  this.state.Commissions && this.state.Commissions.length >0 ? 
															<BarChart className='chartCss' width={1000} height={315} data={this.state.Commissions}
																margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																<CartesianGrid strokeDasharray="3 3" />
																<XAxis dataKey="name" />
																<YAxis orientation="left" >
																	<Label angle={-90} offset={-10} value='Revenue ($)' position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																</YAxis>
																<Tooltip />
																{/* <Legend /> */}
																<Bar dataKey="Commission" fill="#00b5e8" barSize={25} />
															</BarChart>
															:<div className='nodatafound' style={{}}>No data found</div>}
															<p className="overall-title">Commission</p>
														</div>
													</div>
												</div>

											</form>


											<div className="table-responsive verticaltophead margintop15">
												<table className="table table-striped table-bordered table-hover">
													<thead>
														<tr>


															<th>
																Region
																		</th>
															<th>
																Total Turn Over Revenue
																		</th>
															<th>
																Comission
																		</th>


														</tr>
													</thead>
													<tbody>


														{rows && rows.length > 0 ? rows : <tr><td colSpan={4} className="text-center">No user there</td></tr>}



													</tbody>
												</table>
											</div>
										</div>

										<div className={this.state.tabCLicked === 2 ? "tab-pane changePassword active show" : 'tab-pane changePassword'} id="tab_2">



											<form className="width-100">

												<div className="row">
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 tabletpadding0">
														<div className="form-inline inputBg dateBrt beforenone a-auto width100merge">
															<label for="exampleInputEmail1"> Value Range</label>
															<select className="form-control selectBg seltweekly" name="filter5" value={this.state.filter5}
																onChange={this.onChange.bind(this)}
															>
																<option value="1">Weekly</option>
																<option value="2">Monthly</option>
															</select>
														</div>
													</div>
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 tabletpadding0">

													</div>
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 tabletpadding0">
														<div className="form-inline inputBg dateBrt beforenone a-auto width100merge">
															{/* <DatetimeRangePicker
																startDate={this.state.startDate}
																endDate={this.state.endDate}
																onApply={this.handleApplyTabB}
															// ranges={this.state.ranges}

															>
																<div className="input-group">
																	<input type="text" className="form-control" value={label} />
																	<span className="input-group-btn">
																		<Button className="default date-range-toggle">
																			<i className="fa fa-calendar" />
																		</Button>
																	</span>
																</div>
															</DatetimeRangePicker> */}
															{this.renderPickerAutoApply(local, this.handleApplyTabB)}
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 tabletpadding0">



														<div className="m-t-20">
																{this.state.TurnOverF2FONCountrystatistics && this.state.TurnOverF2FONCountrystatistics.Total_Turn_Over  && this.state.TurnOverF2FONCountrystatistics.Total_Turn_Over.length >0 ?
															<BarChart className='chartCss' width={1000} height={300} data={this.state.TurnOverF2FONCountrystatistics.Total_Turn_Over}
																margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																<CartesianGrid strokeDasharray="2 2" />
																<XAxis dataKey="name" />
																<YAxis margin={{ right: 30 }} >

																	<Label angle={-90} offset={-10} value='Revenue ($)' position='insideLeft' style={{ margin: 10, textAnchor: 'middle', color: '#666666' }} />

																</YAxis >
																<Tooltip />
																<Legend />
																<Bar name="Total Turn Over Online" barSize={15} dataKey="Total_Turn_Over_Online" fill="#ff7245" />
																<Bar name="Total Turn Over F2F" barSize={15} dataKey="Total_Turn_Over_F2F" fill="#00b5e8" />
															</BarChart>
															:
															<div className='nodatafound' style={{}}>No data found</div>}
															<p className="overall-title">Total Turn Over Revenue</p>
														</div>
													</div>

													<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 tabletpadding0">

														<div className="m-t-20">
														{ this.state.TurnOverF2FONCountrystatistics &&  this.state.TurnOverF2FONCountrystatistics.Commission && this.state.TurnOverF2FONCountrystatistics.Commission.length > 0 ?
															<BarChart className='chartCss' width={1000} height={300} data={this.state.TurnOverF2FONCountrystatistics.Commission}
																margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																<CartesianGrid strokeDasharray="2 2" />
																<XAxis dataKey="name" />
																<YAxis margin={{ right: 30 }} >

																	<Label angle={-90} offset={-10} value='Revenue ($)' position='insideLeft' style={{ margin: 10, textAnchor: 'middle', color: '#666666' }} />

																</YAxis >
																<Tooltip />
																<Legend />
																<Bar name='Commission Online' barSize={15} dataKey="Commission_Online" fill="#ff7245" />
																<Bar name='Commission F2F' barSize={15} dataKey="Commission_F2F" fill="#00b5e8" />
															</BarChart>
															:
															<div className='nodatafound' style={{}}>No data found</div>}
															<p className="overall-title">Commission</p>
														</div>
													</div>
												</div>

											</form>


											<div className="table-responsive verticaltophead margintop15">
												<table className="table table-striped table-bordered table-hover">
													<thead>
														<tr>
															<th>
																Region
																		</th>
															<th>
																Total Turn Over Online
																		</th>

															<th>
																Total Turn Over F2F
																		</th>
															<th>
																Comission Online
																		</th>
															<th>
																Comission F2F
																		</th>


														</tr>
													</thead>
													<tbody>
														{Revenu_by_appointment_mode && Revenu_by_appointment_mode.length > 0 ? Revenu_by_appointment_mode : <tr><td colSpan={4} className="text-center">No user there</td></tr>}


													</tbody>
												</table>
											</div>



										</div>
										<div className={this.state.tabCLicked === 3 ? "tab-pane changePassword active show" : 'tab-pane changePassword'} id="tab_3">
											<form className="width-100">

												<div className="row">
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 tabletpadding0">
														<div className="form-inline inputBg dateBrt beforenone a-auto width100merge">
															<label for="exampleInputEmail1"> Value Range</label>
															<select className="form-control selectBg seltweekly" name="filter6" value={this.state.filter6}
																onChange={this.onChange.bind(this)}
															>
																<option value="1">Weekly</option>
																<option value="2">Monthly</option>
															</select>
														</div>
													</div>
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 tabletpadding0">

													</div>
													<div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 tabletpadding0">
														<div className="form-inline inputBg dateBrt beforenone a-auto width100merge">
															{/* <DatetimeRangePicker
																startDate={this.state.startDate}
																endDate={this.state.endDate}
																onApply={this.handleApplyTabC}
															// ranges={this.state.ranges}

															>
																<div className="input-group">
																	<input type="text" className="form-control" value={label} />
																	<span className="input-group-btn">
																		<Button className="default date-range-toggle">
																			<i className="fa fa-calendar" />
																		</Button>
																	</span>
																</div>
															</DatetimeRangePicker> */}
															{this.renderPickerAutoApply(local, this.handleApplyTabC)}
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 tabletpadding0">



														<div className="m-t-20">
														{this.state.getRevenewByStatusCountry && this.state.getRevenewByStatusCountry.length >0 ?
															<BarChart className='chartCss' width={1000} height={300} data={this.state.getRevenewByStatusCountry}
																margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																<CartesianGrid strokeDasharray="2 2" />
																<XAxis dataKey="name" />
																<YAxis margin={{ right: 30 }} >
																	{/* <Label offset={-10} angle={-90} value='Revenue ($)' position='insideLeft' style={{ margin: 10, textAnchor: 'middle', color: '#666666' }} /> */}
																</YAxis >
																<Tooltip />
																<Legend />
																<Bar name='Consulted' barSize={15} dataKey="Consulted" fill="#00b5e8" />
																<Bar name='Cancelled By Patient' barSize={15} dataKey="Cancelled_By_Patient" fill="#ff7245" />
																<Bar name='Cancelled By Specialist' barSize={15} dataKey="Cancelled_By_Specialist" fill="#ffc000" />
																<Bar name='No Show Specialist' barSize={15} dataKey="No_Show_Specialist" fill="#45dfac" />
																<Bar name='No show Patient' barSize={15} dataKey="No_show_Patient" fill="#45dfac" />
																<Bar name='Total' barSize={15} dataKey="Total" fill="#a5a5a5" />
															</BarChart>
															:	<div className='nodatafound' style={{}}>No data found</div>}

															<p className="overall-title">Total Appointments</p>
														</div>
													</div>


												</div>

											</form>


											<div className="table-responsive verticaltophead margintop15">
												<table className="table table-striped table-bordered table-hover">
													<thead>
														<tr>
															<th>
																Region
				   </th>
															<th>
																Consulted
				   </th>

															<th>
																Cancelled By Patient
				   </th>
															<th>
																Cancelled By Specialist
				   </th>
															<th>
																No Show Specialist
				   </th>
															<th>
																No Show Patient
				   </th>
															<th>
																Total
					</th>

														</tr>
													</thead>
													<tbody>
														{Overall_appointment_history && Overall_appointment_history.length > 0 ? Overall_appointment_history : <tr><td colSpan={4} className="text-center">No user there</td></tr>}


													</tbody>
												</table>
											</div>
										</div>
										<div className={this.state.tabCLicked === 4 ? "tab-pane changePassword active show" : 'tab-pane changePassword'} id="tab_3">
											{this.state.specialistUserClicked ? <div className="row">
												<div className="col-md-12">
													<div className="tab-content tabother">
														<div className="row">
															<form className="form-inline width-100">
																<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 tabletpadding0">
																	<div className="rows">
																		<div className="form-group inputBg dateBrt beforenone a-auto">
																			<label for="exampleInputEmail1"> Value Range</label>
																			<select className="form-control selectBg seltweekly" name="filter1" value={this.state.Specialistfilter1}
																				onChange={this.onChange.bind(this)}
																			>
																				<option value="1">Weekly</option>
																				<option value="2">Monthly</option>
																			</select>
																		</div>
																	</div>

																	<div className=" m-t-20">

																		{this.state.statistics && this.state.statistics.length > 0 ?
																			<BarChart width={500} height={315} data={this.state.statistics} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																				<CartesianGrid strokeDasharray="3 3" />
																				<XAxis dataKey="_id" />
																				<YAxis>
																					<Label angle={-90} value='No. of Patients' position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																				</YAxis>
																				<Tooltip />
																				<Bar dataKey="Patient1" barSize={25} fill="#22b89f" name="Patient" />
																				<Bar dataKey="Patient2" barSize={25} fill="#00b5e8" name="Patient" />
																				<Bar dataKey="Patient4" barSize={25} fill="#FA4463" name="Patient" />
																				<Bar dataKey="Patient6" barSize={25} fill="#ffffff" name="Patient" />
																			</BarChart> : <div className='nodatafound' style={{}}>No data found</div>
																		}
																		<p className="overall-title">Overall Appointment History</p>
																	</div>
																</div>
																<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 tabletpadding0">
																<div className="form-inline inputBg dateBrt beforenone a-auto width100merge">
															{/* <DatetimeRangePicker
																startDate={this.state.startDate}
																endDate={this.state.endDate}
																onApply={this.handleApplyTabD}
															// ranges={this.state.ranges}

															>
																<div className="input-group">
																	<input type="text" className="form-control marginleft" value={label} />
																	<span className="input-group-btn">
																		<Button className="default date-range-toggle">
																			<i className="fa fa-calendar" />
																		</Button>
																	</span>
																</div>
															</DatetimeRangePicker> */}
															{this.renderPickerAutoApply(local, this.handleApplyTabD)}
														</div>
																	<div className="m-t-20">
																		{
																			this.state.medfixRevStats && this.state.medfixRevStats.length > 0 ?
																				<BarChart width={500} height={315} data={this.state.medfixRevStats}
																					margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																					<CartesianGrid strokeDasharray="3 3" />
																					<XAxis dataKey="Mode" />
																					<YAxis orientation="left" >
																						<Label angle={-90} value='Revenue' position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																					</YAxis>
																					<Tooltip />
																					<Bar dataKey="Revenue" fill="#00b5e8" barSize={25} />
																				</BarChart> :
																				<div className='nodatafound' style={{}}>No data found</div>
																		}
																		<p className="overall-title">Revenue Share with Medfix</p>
																	</div>
																</div>

															</form>
														</div>


														<div className="row">
															<div className="col-md-12">
																<div className="row" style={{ marginTop: 20 }}>
																	<form className="form-inline width-100">
																		<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 tabletpadding0">
																			{/* <div className="rows">
																				<div className="form-group inputBg dateBrt beforenone a-auto">
																					<label for="exampleInputEmail1"> Value Range</label>
																					<select className="form-control selectBg seltweekly" name="filter2" value={this.state.Specialistfilter2}
																						onChange={this.onChange.bind(this)}
																					>
																						<option value="1">Weekly</option>
																						<option value="2">Monthly</option>
																					</select>
																				</div>
																			</div> */}

																			<div className="m-t-20">

																				<div className="">
																					{this.state.rateStats && this.state.rateStats.length > 0 ? <BarChart width={500} height={300} data={this.state.rateStats} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																						<CartesianGrid strokeDasharray="3 3" />
																						<XAxis dataKey="abriv" />
																						<YAxis orientation="left" >
																							<Label angle={-90} value='No. of Patients' position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																						</YAxis>
																						<Tooltip content={<CustomTooltip />}/>
																						
																						<Bar dataKey="averageValue" name="Average Rating" barSize={15} fill="#00b5e8" />
																					</BarChart>
																						: <div className='nodatafound' style={{}}>No data found</div>
																					}

																					<p className="overall-title" style={{ whiteSpace: "nowrap" }}>Overall Patient Satisification</p>
																				</div>
																			</div>

																		</div>
																		<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 tabletpadding0">
																			{/* <div className="form-group inputBg dateBrt beforenone a-auto">
																				<label for="exampleInputEmail1"> Value Range</label>
																				<select className="form-control selectBg seltweekly" name="filter3" value={this.state.Specialistfilter3}
																					onChange={this.onChange.bind(this)}
																				>
																					<option value="1">Weekly</option>
																					<option value="2">Monthly</option>
																				</select>
																			</div> */}
																			<div className="m-t-20">
																				{
																					this.state.appRevStats && this.state.appRevStats.length > 0 ?
																						<BarChart width={500} height={300} data={this.state.appRevStats}
																							margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																							<CartesianGrid strokeDasharray="3 3" />
																							<XAxis dataKey="Mode" />
																							<YAxis orientation="left" >
																								<Label angle={-90} value='Revenue' position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																							</YAxis>
																							{/* <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" /> */}
																							<Tooltip />
																							{/* <Legend /> */}
																							<Bar dataKey="Revenue" fill="#00b5e8" barSize={25} />
																							{/* <Bar yAxisId="right" dataKey="Patients" fill="#82ca9d" barSize={30} /> */}
																						</BarChart> :
																						<div className='nodatafound' style={{}}>No data found</div>
																				}
																				<p className="overall-title">Revenue by Appointment Mode</p>
																			</div>

																		</div>

																	</form>
																</div>

															</div>
														</div>

													</div>
												</div>
											</div>

												:


												<div className="row">
													<div className="col-md-12">
														<div className="tab-content tabother ">
															<div className="row">
																<div className="box-body table-responsive no-padding aTable" id="tab_1">
																	<div className="table-responsive">
																		<table className="table">
																			<tbody>
																				<tr>
																					<th
																						onClick={this.sortChanged.bind(
																							this,
																							"users.userName",
																							this.state.sortOrder
																						)}
																					>
																						Name
                                    <i
																							className={this._sortClass(
																								"appointmentspecialistname"
																							)}
																						/>
																					</th>
																					<th
																						onClick={this.sortChanged.bind(
																							this,
																							"qualification",
																							this.state.sortOrder
																						)}
																					>
																						Qualification<i
																							className={this._sortClass(
																								"appointmentspecialistname"
																							)}
																						/>
																					</th>
																					<th
																						onClick={this.sortChanged.bind(
																							this,
																							"specializations.specialization",
																							this.state.sortOrder
																						)}
																					>
																						Specialization<i
																							className={this._sortClass(
																								"appointmentspecialistname"
																							)}
																						/>
																					</th>
																					<th
																						onClick={this.sortChanged.bind(
																							this,
																							"users.email",
																							this.state.sortOrder
																						)}
																					>
																						Email<i
																							className={this._sortClass(
																								"appointmentspecialistname"
																							)}
																						/>
																					</th>
																					<th>Action</th>
																				</tr>
																				{allSpecialist && allSpecialist.length > 0 ? (
																					allSpecialist
																				) : (
																						<tr>
																							<td colSpan={4} className="text-center">
																								No users
                                    </td>
																						</tr>
																					)}
																			</tbody>
																		</table>
																	</div></div>
															</div>
															{specialistList && specialistList.length > 0 ? (
																<div className="row">
																	<div className="col-sm-5">
																		<div className="showingEntries">
																			Showing{" "}
																			{this.state.activePage * this.state.count -
																				(this.state.count - 1)}{" "}
																			to{" "}
																			{this.state.activePage * this.state.count >
																				this.state.totalCount
																				? this.state.totalCount
																				: this.state.activePage * this.state.count}{" "}
																			of {this.state.totalCount} entries
                            </div>  </div>
																	<div
																		className="col-sm-7 text-right"
																		style={{ cursor: "pointer" }}
																	>
																		<Pagination
																			prevPageText="Prev"
																			nextPageText="Next"
																			hideFirstLastPages
																			activePage={this.state.activePage}
																			itemsCountPerPage={10}
																			totalItemsCount={this.state.totalCount}
																			pageRangeDisplayed={10}
																			onChange={this.handlePageChange.bind(this)}
																		/>
																	</div>
																</div>
															) : (
																	""
																)}
														</div>
													</div>
												</div>
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>
				</div>
			</div>

		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		statistics: state.statistics.statistics,
		rateStats: state.statistics.rateStats,
		appRevStats: state.statistics.appRevStats,
		medfixRevStats: state.statistics.medfixRevStats,
		TurnOverCountrystatistics: state.statistics.TurnOverCountrystatistics ? state.statistics.TurnOverCountrystatistics.TotolRevenu : '',
		Commissions: state.statistics.TurnOverCountrystatistics ? state.statistics.TurnOverCountrystatistics.medfixRevenu : '',
		TurnOverF2FONCountrystatistics: state.statistics.TurnOverF2FONCountrystatistics ? state.statistics.TurnOverF2FONCountrystatistics : '',
		getRevenewByStatusCountry: state.statistics.getRevenewByStatusCountry ? state.statistics.getRevenewByStatusCountry.CountryWiseStateData : '',
		specialistList: state.vettingUser.specialistList.specialistData ? state.vettingUser.specialistList.specialistData : '',
		specialistListCount: state.vettingUser.specialistList.totalcount ? state.vettingUser.specialistList.totalcount : 0,
	}
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(adminDashboardActions, dispatch),
		action: bindActionCreators(statisticsActions, dispatch),
		specialistAction: bindActionCreators(vettingUserActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(FinanceDashboard);
